import React, { Component } from 'react';
import { Form, Popover, Table } from 'antd';
import { Link } from 'react-router';
import moment from 'moment';
import util from '@util/index';
import '../expenses.less';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: this.props.dataSource,
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataSource: nextProps.dataSource,
    });
  }

  handleChange = (pagination, filters, sorter) => {
    this.props.onChange(pagination, filters, sorter);
  };

  columns = () => {
    const {
      dataSource: { pagination },
    } = this.state;
    const current = pagination.current || 1;
    const total = pagination.total || 0;
    let config = [
      {
        title: '编号',
        dataIndex: 'num',
        render: (text, record, index) => {
          return <span>{total - (current - 1) * 15 - index}</span>;
        },
      },
      {
        title: '采购单号',
        dataIndex: 'no',
        render: (text, record) => {
          return (
            <Link to={`/administrative/purchase_manage/open/${record.uuid}`}>{text || '查看'}</Link>
          );
        },
      },
      {
        title: '金额',
        dataIndex: 'price',
        key: 'price',
        render: text => <span>{util.numberFormat(text, 2, '.', ',')}</span>,
      },
      {
        title: '申请理由',
        dataIndex: 'reason',
        key: 'reason',
        width: 200,
        render: text => {
          const content = (
            <div style={{ maxWidth: '600px' }}>
              <span>{text}</span>
            </div>
          );
          return (
            <Popover content={content}>
              <p className="ellip">{text}</p>
            </Popover>
          );
        },
      },
      {
        title: '申请人',
        dataIndex: 'createUserName',
        key: 'createUserName',
      },
      {
        title: '申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: text => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '当前环节-处理人',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => {
          const instance = record.instance || {};
          const currentActivity = instance.currentActivity || {};
          const { name, processorName } = currentActivity;
          return <span>{currentActivity.uuid ? `${name || ''}-${processorName || ''}` : ''}</span>;
        },
      },
      {
        title: '完成时间',
        dataIndex: 'finishTime',
        key: 'finishTime',
        render: (text, record) => {
          const a = moment.unix(record.finishTime / 1000);
          const b = moment.unix(record.createTime / 1000);
          return (
            <span>
              {record.finishTime ? (
                <span>
                  {moment.unix(record.finishTime / 1000).format('YYYY-MM-DD')}
                  <span>(用时{a.diff(b, 'days')}天)</span>
                </span>
              ) : (
                ''
              )}
            </span>
          );
        },
      },
      {
        title: '状态',
        dataIndex: 'status',
        render: (text, record) => {
          record.status = record.status === 0 || record.status === 1 ? record.status : 2;
          if (record.status === 0) {
            return <span>审核中</span>;
          }
          if (record.status === 1) {
            return <span style={{ color: 'red' }}>已完成</span>;
          }
          return <span>待编辑</span>;
        },
      },
      // {
      //   title: "操作",
      //   dataIndex: "done",
      //   render: (text, record) => {
      //     return (
      //       <Link to={`/administrative/purchase_manage/open/${record.uuid}`}>
      //         查看
      //       </Link>
      //     );
      //   }
      // }
    ];
    if (this.props.type === 'mine') {
      config = config.filter(item => item.dataIndex !== 'createUserName');
    }
    return config;
  };

  render() {
    const {
      dataSource: { list, pagination },
    } = this.state;
    return (
      <Table
        rowKey="uuid"
        dataSource={list}
        pagination={pagination}
        columns={this.columns()}
        loading={this.props.loading}
        onChange={this.handleChange}
      />
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/administrative/purchase/TableExpenses.js